import yesNoModel from './yesNoModel';
import customValidator from '../validators/customValidator';

const basicInformationModel = () => {
  return {
    sections: [
      {
        title: 'Referral Information',
        rows: [
          {
            cols: [
              {
                label: 'Program Referred for',
                mapTo: 'programId',
                required: false,
                isInvalid: false,
                optionType: 'Program',
                type: 'select',
                style: {
                  width: '348px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Referring Case Manager/Counselor Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'Full Name',
                mapTo: 'caseManager.fullName',
                required: false,
                isInvalid: false,
                style: {
                  width: '348px',
                },
                maxLength: 50,
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.caseManager;
                  return customValidator.validateDependantRequiredColumn(
                    'Referring Case Manager/Counselor Contact Information',
                    'Full Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) => data.agency,
                    errors);
                }
              },
              {
                label: 'Agency',
                mapTo: 'caseManager.agency',
                required: false,
                isInvalid: false,
                maxLength: 50,
              },
            ],
          },
        ],
      },
      {
        title: 'Basic Information',
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            style: {
              paddingLeft: 0,
            },
            cols: [
              {
                label: 'Personal Demographics',
                type: 'label',
                className: 'sub-title'
              }
            ]
          },
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'firstName',
                required: true,
                isInvalid: false,
                maxLength: 20,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Middle Name',
                mapTo: 'middleName',
                required: false,
                isInvalid: false,
                maxLength: 20,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Last Name',
                mapTo: 'lastName',
                required: true,
                isInvalid: false,
                maxLength: 20,
                style: {
                  width: '230px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Date of Birth',
                mapTo: 'dateOfBirth',
                type: 'date',
                required: true,
                isInvalid: false,
                style: {
                  width: '207px',
                },
              },
              {
                label: 'Social Security Number',
                mapTo: 'socialSecurityNumber',
                validation: undefined,
                required: false,
                isInvalid: false,
                isSocialSecurityNumber: true,
                maxLength: 11,
                style: {
                  width: '378px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'address',
                validation: undefined,
                required: false,
                isInvalid: false,
                style: {
                  width: '469px',
                },
              },
              {
                label: 'Apt. #',
                mapTo: 'apartmentNumber',
                validation: undefined,
                required: false,
                isInvalid: false,
                maxLength: 10,
                style: {
                  width: '174px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'County of Residence',
                mapTo: 'CountyOfResidenceId',
                validation: undefined,
                required: false,
                isInvalid: false,
                optionType: 'County',
                type: 'select',
                style: {
                  width: '311px',
                },
              },
              {
                label: 'County of Financial Residence',
                mapTo: 'CountyOfFinancialId',
                validation: undefined,
                required: false,
                isInvalid: false,
                optionType: 'County',
                type: 'select',
                style: {
                  width: '311px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'city',
                validation: undefined,
                required: false,
                isInvalid: false,
                maxLength: 40,
                style: {
                  width: '311px',
                },
              },
              {
                label: 'State',
                mapTo: 'state',
                validation: undefined,
                required: false,
                isInvalid: false,
                maxLength: 2,
                style: {
                  width: '84px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'zipCode',
                validation: undefined,
                required: false,
                isInvalid: false,
                maxLength: 10,
                style: {
                  width: '134px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Home Phone Number',
                mapTo: 'homePhoneNumber',
                type: 'tel',
                validation: undefined,
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {},
              },
              {
                label: 'Cell Phone Number',
                mapTo: 'cellPhoneNumber',
                type: 'tel',
                validation: undefined,
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {},
              },
              {
                label: 'E-mail',
                mapTo: 'email',
                type: 'text',
                validation: undefined,
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {},
              },
            ],
          },
          {
            cols: [
              {
                label: 'Marital Status',
                mapTo: 'maritalStatusId',
                validation: undefined,
                required: false,
                optionType: 'MaritalStatus',
                type: 'radio',
                isInvalid: false,
                inline: true,
                className: 'inline-radio-items'
              },
            ],
          },
          {
            cols: [
              {
                label: 'Ethnicity',
                mapTo: 'ethnicityId',
                validation: undefined,
                required: false,
                optionType: 'Ethnicity',
                type: 'select',
                isInvalid: false,
                inline: true,
                style: {
                  width: '308px'
                }
              },
            ],
          },
          {
            cols: [
              {
                label: 'Language',
                mapTo: 'language',
                validation: undefined,
                required: false,
                isInvalid: false,
                maxLength: 50,
                type: 'text',
                style: {
                  width: '308px'
                }
              },
              {
                label: 'Is an interpreter needed?',
                mapTo: 'isInterpreterNeeded',
                validation: undefined,
                required: false,
                options: yesNoModel().yesNo,
                isInvalid: false,
                type: 'radio',
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Is the referred individual a Veteran?',
                mapTo: 'isVeteran',
                validation: undefined,
                required: false,
                options: yesNoModel().yesNo,
                isInvalid: false,
                type: 'radio',
                inline: true,
              },
            ],
          },
        ],
      },
      {
        title: 'Personal History',
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                label: 'Criminal History',
                type: 'label',
                className: 'sub-title'
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Is there anything that would show up on a background check that could disqualify this individual from employment?',
                mapTo: 'couldDisqualifyFromEmployment',
                validation: undefined,
                required: false,
                options: yesNoModel().yesNo,
                isInvalid: false,
                type: 'radio',
                inline: true,
                style: {
                  paddingLeft: '15px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Does this individual have a history of any of the following: (check all that apply)',
                mapTo: 'options',
                validation: undefined,
                required: false,
                optionType: 'PersonalIndividualHistory',
                isInvalid: false,
                type: 'checkbox',
                inline: true,
                includeOther: true,
                otherMapTo: 'individualHistoryOther',
                maxLength: 300,
                style: {
                  paddingLeft: '15px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Medical History',
                mapTo: 'medicalHistory',
                validation: undefined,
                required: false,
                isInvalid: false,
                style: {
                  width: '450px',
                },
                type: 'textarea',
                rows: 3,
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Has this individual been hospitalized within the last five years?',
                mapTo: 'isHospitalizedLastFiveYears',
                type: 'radio',
                required: false,
                options: yesNoModel().yesNo,
                isInvalid: false,
                inline: true,
                className: 'inline-radio-items'
              },
            ],
          },
          {
            cols: [
              {
                label: 'If yes, for what reason',
                mapTo: 'hospitalizedLastFiveYearsReason',
                validation: undefined,
                required: false,
                isInvalid: false,
                type: 'text',
              },
            ],
          },
        ],
      },
    ],
  };
};

export default basicInformationModel;
